// Подписи на трёх языках сайта без зависимости от файлов переводов:
// они есть только на боевом сервере. Язык - тот, что выбран на сайте.
export function tr(uk, ru, en, zh) {
  const texts = { uk, ru, en, zh };
  return texts[window.language] || ru;
}

// текст отказа из ответа API (ошибки полей и общие сообщения)
export function readApiError(e, fallback) {
  if (!e || typeof e.json !== 'function') {
    return Promise.resolve(fallback);
  }

  return e.json().then(body => {
    const messages = [];
    const collect = value => {
      if (!value) return;
      if (Array.isArray(value)) { value.forEach(collect); return; }
      if (typeof value === 'object') {
        if (value.message) messages.push(value.message);
        else Object.values(value).forEach(collect);
        return;
      }
      messages.push(String(value));
    };

    (body.errors || []).forEach(error => collect(error.state || error.message));

    return messages.filter(Boolean).join(' ') || body.message || fallback;
  }).catch(() => fallback);
}
